module.exports = __webpack_public_path__ + "packs/media/images/brand_black-264953c0fa8b93f2e36bf5f6ca44899a.svg";